import tyreStack from "../images/tyres.png";

function Booking() {
  return(
  <>
  <div className="hero justify-start bg-zinc-800 text-white font-rescue italic">
        <div className="flex flex-row items-center">
          <div className="flex flex-col gap-10 ml-10 p-20 font-bold w-full md:w-1/2">
          <ul className="steps steps-vertical font-rescue">
  <li className="step step-primary !text-left">Enter Tyre Size</li>
  <li className="step step-primary !text-left">Choose Budget or Premium</li>
  <li className="step step-primary !text-left">Select or Input Brand</li>
  <li className="step step-primary !text-left">Pay £10 Deposit</li>
  <li className="step step-primary !text-left">We'll be in touch to confirm your booking</li>
</ul>
          </div>
          <div className="hidden md:flex md:flex-col md:p-20 md:justify-center items-center md:font-bold md:w-1/2">
            <img
            src={tyreStack}
            width={400}
            className="max-w-sm" 
            alt="tyre stack"
            />
            <button className="btn w-1/2 text-white bg-rescueRed hover:text-rescueRed hover:bg-white">Book Now</button>
          </div>
        </div>
      </div>
  </>
  )
}

export default Booking;
